import { useId } from "react";

export const InstagramIcon = ({ className = "h-5 w-5" }) => {
  const id = useId().replace(/:/g, "");
  const gid = `ig-gradient-${id}`;
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={gid} x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#feda75">
            <animate attributeName="stop-color" values="#feda75;#fa7e1e;#d62976;#962fbf;#4f5bd5;#feda75" dur="6s" repeatCount="indefinite" />
          </stop>
          <stop offset="50%" stopColor="#d62976">
            <animate attributeName="stop-color" values="#d62976;#962fbf;#4f5bd5;#feda75;#fa7e1e;#d62976" dur="6s" repeatCount="indefinite" />
          </stop>
          <stop offset="100%" stopColor="#4f5bd5">
            <animate attributeName="stop-color" values="#4f5bd5;#feda75;#fa7e1e;#d62976;#962fbf;#4f5bd5" dur="6s" repeatCount="indefinite" />
          </stop>
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="20" height="20" rx="5" ry="5" stroke={`url(#${gid})`} strokeWidth="2" />
      <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" stroke={`url(#${gid})`} strokeWidth="2" />
      <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" stroke={`url(#${gid})`} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};
